import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { TimeInput } from '../common/TimeInput';
import { Panel, Button, Alert, Grid, Row, Col } from 'react-bootstrap';
import { parseTime } from "../../extensions/dateHelper";
import * as permissions from "../../constants/permissions"

import { getSettings, updateSettings, clearUpdateSettings } from '../../actions/settings';
import * as fetchingState from '../../constants/fetchingState';

import { defaultWorkTime } from '../../constants/settingTypes';
import moment from "moment";

const required = (values) => {
    const errors = {};
    Object.keys(values).forEach((type) => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    });
    return errors;
}

const validate = (values) => {
    const errors = required(values);

    if (Object.keys(errors).length > 0 || Object.keys(values).length === 0)
        return errors;

    const { PickupStartTime, PickupEndTime, OffloadStartTime, OffloadEndTime } = values;
    if (parseTime(PickupStartTime) >= parseTime(PickupEndTime))
        errors._error = "*Конец времени для приема вещей больше начала";

    if (parseTime(OffloadStartTime) >= parseTime(OffloadEndTime))
        errors._error = "*Конец времени для доставки вещей больше начала";

    return errors;
}

let DefaultWorkTimeSettings = class extends React.Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
        this._resetForm = this._resetForm.bind(this);
        this._load = this._load.bind(this);
    }

    _onSubmit(values) {
        const timeZoneOffset = new Date().getTimezoneOffset() / 60;
        const editModel = {...values};
        editModel.PickupStartTime = moment(editModel.PickupStartTime, 'HH:mm').add(timeZoneOffset, 'hours').format('HH:mm');
        editModel.PickupEndTime = moment(editModel.PickupEndTime, 'HH:mm').add(timeZoneOffset, 'hours').format('HH:mm');
        editModel.OffloadStartTime = moment(editModel.OffloadStartTime, 'HH:mm').add(timeZoneOffset, 'hours').format('HH:mm');
        editModel.OffloadEndTime = moment(editModel.OffloadEndTime, 'HH:mm').add(timeZoneOffset, 'hours').format('HH:mm');
        this.props.updateSettings(defaultWorkTime, editModel);
    }

    _resetForm() {
        this.props.clearUpdateSettings(defaultWorkTime);
    }

    _load() {
        this.props.clearUpdateSettings(defaultWorkTime);
        this.props.getSettings(defaultWorkTime);
    }

    componentDidMount() {
        this.props.getSettings(defaultWorkTime);
    }

    render() {
        const { handleSubmit, fetching, updateFetching, anyTouched, error, crudError } = this.props;
        const formVisible = fetching === fetchingState.FETCHED && updateFetching === fetchingState.INITIAL;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        return (
            <Panel>
                <Panel.Heading>Рабочий день по умолчанию</Panel.Heading>
                <Panel.Body>
                    {formVisible && <form className='form-horizontal'>
                        <Grid fluid={true} cellPadding='0px'>
                            <Row>
                                <Col lg={12}>
                                    <label className="control-label">Прием вещей</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={5} md={5} sm={5} xs={5}>
                                    <Field disabled={isReadOnly} name='PickupStartTime' component={TimeInput} />
                                </Col>
                                <Col lg={2} md={2} sm={1} xs={1} >
                                    <hr style={{ borderTop: '1px solid black', marginTop: '17px' }} />
                                </Col>
                                <Col lg={5} md={5} sm={5} xs={5}>
                                    <Field disabled={isReadOnly} name='PickupEndTime' component={TimeInput} />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <label className="control-label">Возврат вещей</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={5} md={5} sm={5} xs={5}>
                                    <Field disabled={isReadOnly} name='OffloadStartTime' component={TimeInput} />
                                </Col>
                                <Col lg={2} md={2} sm={1} xs={1}>
                                    <hr style={{ borderTop: '1px solid black', marginTop: '17px' }} />
                                </Col>
                                <Col lg={5} md={5} sm={5} xs={5}>
                                    <Field disabled={isReadOnly} name='OffloadEndTime' component={TimeInput} />
                                </Col>
                            </Row>
                        </Grid>
                        {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                        <div style={{ margin: '5px', marginTop: '7px', float: 'right' }}>
                            <Button disabled={isReadOnly} bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)}>Сохранить</Button>
                        </div>
                    </form>}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
                    {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
                    {updateFetching === fetchingState.FETCHING && <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {updateFetching === fetchingState.FETCHED && <div>
                        <Alert bsStyle='success'>Настройки успешно обновлены</Alert>
                        <Button bsStyle="primary" onClick={this._resetForm}>Закрыть</Button>
                    </div>}
                    {updateFetching === fetchingState.FAILED && <div>
                        <Alert bsStyle='danger'>
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                        <Button onClick={this._load}>Закрыть</Button>
                    </div>}
                </Panel.Body>
            </Panel>);
    }
}

DefaultWorkTimeSettings = reduxForm({
    form: 'defaultWorkTimeSettingsEdit',
    enableReinitialize: true,
    validate
})(DefaultWorkTimeSettings)

DefaultWorkTimeSettings = connect(state => {
    const { data, fetching, updateFetching } = state.application.get('settings')[defaultWorkTime];
    const initialData = {...data};
    const timeZoneOffset = new Date().getTimezoneOffset() / 60;
    initialData.PickupStartTime = initialData.PickupStartTime ? moment(data.PickupStartTime, 'HH:mm').add(-timeZoneOffset, 'hours').format('HH:mm') : initialData.PickupStartTime;
    initialData.PickupEndTime = initialData.PickupEndTime ? moment(data.PickupEndTime, 'HH:mm').add(-timeZoneOffset, 'hours').format('HH:mm') : initialData.PickupEndTime;
    initialData.OffloadStartTime = initialData.OffloadStartTime ? moment(data.OffloadStartTime, 'HH:mm').add(-timeZoneOffset, 'hours').format('HH:mm') : initialData.OffloadStartTime;
    initialData.OffloadEndTime = initialData.OffloadEndTime ? moment(data.OffloadEndTime, 'HH:mm').add(-timeZoneOffset, 'hours').format('HH:mm') : initialData.OffloadEndTime;
    return { initialValues: initialData, fetching, updateFetching }
}, { getSettings, updateSettings, clearUpdateSettings })(DefaultWorkTimeSettings);

export default DefaultWorkTimeSettings;


// WEBPACK FOOTER //
// ./src/components/settings/DefaultWorkTime.jsx